import { useTranslation } from "react-i18next";

type Props = {
  exerciseExists: boolean;
  onSaveAnyway: () => void;
  onBack: () => void;
};

// Same reasoning as ModelMissingDialog: the browser confirm offered OK and Cancel and left
// the author at the same save button afterwards. Here the two ways out are named.
export const NoCorrectAnswerDialog = (props: Props): JSX.Element => {
  const { t } = useTranslation();

  return (
    <div className="modal is-active">
      <div className="modal-background" onClick={props.onBack}></div>
      <div className="modal-card" style={{ width: "min(44rem, 92vw)", height: "auto" }}>
        <header className="modal-card-head">
          <p className="modal-card-title">{t("noCorrectAnswerTitle")}</p>
          <button className="delete" aria-label="close" onClick={props.onBack}></button>
        </header>
        <section className="modal-card-body">
          <p>{t("noCorrectAnswerDialogText")}</p>
          <p className="mt-2">{t(props.exerciseExists ? "exerciseCreatedForModel" : "exerciseCreatedOnSave")}</p>
        </section>
        <footer className="modal-card-foot" style={{ flexWrap: "wrap", gap: "0.5rem" }}>
          <button className="button is-success" onClick={props.onSaveAnyway}>
            {t("saveWithoutCorrectAnswer")}
          </button>
          <button className="button" onClick={props.onBack}>
            {t("backToForm")}
          </button>
        </footer>
      </div>
    </div>
  );
};
